import React from 'react'
import ErrorMessage from 'common/components/ErrorMessage'
import Eula from 'sprockets_react/job_wizards/components/Eula'
import { JobWizard } from 'sprockets_react/job_wizards/registries'

JobWizard.CreateAccount = class CreateAccount extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.setupValidation()
  }

  setupValidation() {
    let validator = JobWizard.Validator

    validator.addField('first_name',
      {
        validators: {
          notEmpty: {
            message: 'Please enter your first name'
          }
        }
      }
    )

    validator.addField('contact_phone',
      {
        validators: {
          notEmpty: {
            message: 'Please enter your contact number'
          }
        }
      }
    )
  }

  render() {
    return (
      <div className="create-account">
        <h3 className="mb15 mt20">First Name & Contact Number</h3>
        <ErrorMessage />
        <div className="form-group">
          <input type="text" className="form-control" name="first_name" id="first-name" placeholder="First Name" />
        </div>
        <div className="form-group">
          <input type="text" className="form-control" name="contact_phone" id="contact-phone" placeholder="Contact Number" />
        </div>
        { Eula.renderApp({ marginTop: '40px', marginBottom: '40px' }) }
      </div>
    )
  }
}
